var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-section"},[_c('div',{staticClass:"news-section-content"},[_c('span',{class:{
        'text-body2': _vm.$mq === 'xl' || _vm.$mq === 'l',
        'text-body3': _vm.$mq === 'm',
        'text-body6': _vm.$mq === 's'
      }},[_vm._v(_vm._s(_vm.date))]),_c('h2',{staticClass:"red",class:{
        'text-h2': _vm.$mq === 'xl' || _vm.$mq === 'l',
        'text-h3': _vm.$mq === 'm',
        'text-h5': _vm.$mq === 's'
      }},[_vm._v("\n      "+_vm._s(_vm.header)+"\n    ")]),_c('p',{class:{
        'text-body3': _vm.$mq === 'xl' || _vm.$mq === 'l',
        'text-body5': _vm.$mq === 'm',
        'text-body6': _vm.$mq === 's'
      }},[_vm._v("\n      "+_vm._s(_vm.desc)+"\n    ")])]),_c('div',{staticClass:"news-section-imgDiv"},[(_vm.img)?_c('img',{staticClass:"news-section-img",attrs:{"src":require(("@/assets/images/News/" + _vm.img)),"alt":'news' + _vm.ind + '_pic'}}):_vm._e(),_c('div',{staticClass:"news-section-img-filer"})])])}
var staticRenderFns = []

export { render, staticRenderFns }